<template>
  <div id="app">
    <header class="header">
      <h1 class="header-title">Segelflugclub Erfurt e.V.</h1>
    </header>

    <router-view class="container"></router-view>

    <b-navbar variant="light" bg="light" class="footer justify-content-around" v-if="currentRouteName !== 'LoginView'">
      <b-navbar-nav class="mb-3">
        <b-nav-item to="/" :class="{ active: $route.path === '/' }">
          <font-awesome-icon icon="newspaper" style="font-size: 1.5em" />
          <small>Aktuelles</small>
        </b-nav-item>
        <b-nav-item to="/attendance" :class="{ active: $route.path === '/attendance' }">
          <font-awesome-icon icon="fa-solid fa-calendar-days" style="font-size: 1.5em" />
          <small>Termine</small>
        </b-nav-item>
        <b-nav-item to="/flight-operations" :class="{ active: $route.path === '/flight-operations' }">
          <font-awesome-icon icon="fa-solid fa-plane" style="font-size: 1.5em" />
          <small>Flugbetrieb</small>
        </b-nav-item>
        <!--b-nav-item href="#" @click="notImplemented()">
          <font-awesome-icon icon="fa-solid fa-graduation-cap" style="font-size: 1.5em" />
          <small>Schulung</small>
        </b-nav-item-->
        <b-nav-item to="/account" :class="{ active: $route.path === '/account' }">
          <font-awesome-icon icon="circle-user" style="font-size: 1.5em" />
          <small>Account</small>
        </b-nav-item>
      </b-navbar-nav>
    </b-navbar>
    
  </div>
  
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  data() {
    return {
      showInstallPrompt: false,
      deferredPrompt: null,

      maintenanceMode: process.env.VUE_APP_MAINTENANCE_MODE,
    };
  },
  methods: {
    

  },
  computed: {
    currentRouteName() {
        return this.$route.name;
    }
  },

  mounted() {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      this.deferredPrompt = e;
      this.showInstallPrompt = true;
    });
  }
};

</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  display: flex;
  flex-direction: column;
  height: 100vh;
}


.header {
  background: linear-gradient(180deg, #b02a2a, #ff4b5c);
  padding: 40px;
  text-align: center;
  border-radius: 0 0 15px 15px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 0.5rem;
  flex-shrink: 0;
}

.header-title {
  font-size: 1em;
  color: white;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin: 0;
}

.container {
  margin: 0 auto;
  flex: 1;
  overflow-y: auto;
}

.footer {
  text-align: center;
  padding: 10px 0;
  flex-shrink: 0;
}

.b-card-body {
  border-radius: 8px;
}

small {
  display: block;
  text-align: center;
  font-size: 0.8em;
}

.active {
  background-color: #e5e5e5;
  border-radius: 7px;
}


.install-prompt {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #fff;
  padding: 10px 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 11;
}

.install-prompt-ios {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #fff;
  padding: 10px 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 11;
}
</style>
